// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form_wrapper__1xHDH","form":"Form_form__1BMNE","checkboxWrapper":"Form_checkboxWrapper__1J55r"};